import * as TYPES from "../../consts/actionsTypes";
import { CookieHandler as CookieManager } from "../../handlers";
import { clearCookies, setCookies } from "../api/cookiebar.api";

export const acceptCookie = (
  setAll = false,
  statistics = false,
  marketing = false,
  performance = false,
  currentPageId = ""
) => {
  try {
    return (dispatch) => {
      const CookieHandler = new CookieManager(true);
      const accepted = true;

      CookieHandler.set(TYPES.COOKIEBAR_COOKIE, {
        accepted: accepted,
        set: true,
      });
      const setComplete = setCookies(
        setAll ? true : false,
        statistics,
        // marketing,
        performance,
        currentPageId
      );
      if (setComplete) {
        dispatch({
          type: TYPES.COOKIEBAR_COOKIE__SET,
          accepted,
        });
      }
    };
  } catch (error) {}
};

export const declineCookie = () => {
  return (dispatch) => {
    const CookieHandler = new CookieManager();
    const accepted = false;
    CookieHandler.set(
      TYPES.COOKIEBAR_COOKIE,
      {
        accepted: accepted,
        set: true,
      },
      1
    );
    dispatch({
      type: TYPES.COOKIEBAR_COOKIE__SET,
      accepted,
    });
  };
};

export const removeCookies = () => {
  return (dispatch) => {
    const cookieCleared = clearCookies();
    if (cookieCleared) {
      dispatch({
        type: TYPES.COOKIEBAR_COOKIE__CLEARALL,
      });
    }
  };
};
